import React from 'react';

const InstagramIcon = () => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      x='0px'
      y='0px'
      width='25'
      height='25'
      viewBox='0 0 172 172'
      style={{ fill: '#000000' }}
    >
      <g
        fill='none'
        fillRule='nonzero'
        stroke='none'
        strokeWidth='1'
        strokeLinecap='butt'
        strokeLinejoin='miter'
        strokeMiterlimit='10'
        strokeDasharray=''
        strokeDashoffset='0'
        fontFamily='none'
        fontWeight='none'
        fontSize='none'
        textAnchor='none'
        style={{ mixBlendMode: 'normal' }}
      >
        <path d='M0,172v-172h172v172z' fill='none'></path>
        <g fill='#ffffff'>
          <path d='M61.64453,26.875c-19.08545,0 -34.76953,15.66309 -34.76953,34.76953v48.71094c0,19.08545 15.66309,34.76953 34.76953,34.76953h48.71094c19.08545,0 34.76953,-15.66308 34.76953,-34.76953v-48.71094c0,-19.08545 -15.66308,-34.76953 -34.76953,-34.76953zM61.64453,37.625h48.71094c13.29053,0 24.01953,10.72901 24.01953,24.01953v48.71094c0,13.29053 -10.72901,24.01953 -24.01953,24.01953h-48.71094c-13.29053,0 -24.01953,-10.72901 -24.01953,-24.01953v-48.71094c0,-13.29053 10.72901,-24.01953 24.01953,-24.01953zM117.74609,49.38281c-2.70849,0 -4.87109,2.1626 -4.87109,4.87109c0,2.70849 2.1626,4.87109 4.87109,4.87109c2.70849,0 4.87109,-2.1626 4.87109,-4.87109c0,-2.70849 -2.1626,-4.87109 -4.87109,-4.87109zM86,53.75c-17.7417,0 -32.25,14.5083 -32.25,32.25c0,17.7417 14.5083,32.25 32.25,32.25c17.7417,0 32.25,-14.5083 32.25,-32.25c0,-17.7417 -14.5083,-32.25 -32.25,-32.25zM86,64.5c11.94678,0 21.5,9.55322 21.5,21.5c0,11.94678 -9.55322,21.5 -21.5,21.5c-11.94678,0 -21.5,-9.55322 -21.5,-21.5c0,-11.94678 9.55322,-21.5 21.5,-21.5z'></path>
        </g>
      </g>
    </svg>
  );
};

export default InstagramIcon;
